import { createAction } from '@reduxjs/toolkit'

export const prices = createAction<{prices: any}>('account/prices');
export const balance = createAction<{balance: any}>('account/balance');
export const accounts = createAction<{accounts: any}>('account/accounts');
export const currentAccount = createAction<{currentAccount: any}>('account/currentAccount');
export const balances = createAction<{balances: any}>('account/balances');
export const account = createAction<{account: any}>('account');

